export default __webpack_public_path__ + "static/media/portfolio7.507a13ad.webp";